import React, { useState } from "react";
import AuthKey from "../components/AuthKey";
import LoadPublications from "../components/LoadPublications";
import LoadTotalPages from "../components/LoadTotalPages";
import SetProject from "../components/SetProject";
import { Dashboard } from "./Dashboard";

/**
 * Index page
 *
 * @constructor
 */
export const Index = () => {
	const [isLoadedPublications, setLoadedPublications] = useState(false);
	const [isLoadedPages, setLoadedPages] = useState(false);

	return (
		<>
			<AuthKey/>
			<SetProject/>
			<LoadPublications setLoaded={setLoadedPublications}/>
			{isLoadedPublications && <LoadTotalPages setLoaded={setLoadedPages}/>}
			{isLoadedPages && <Dashboard/>}
		</>
	);
};

export default Index;
